import {useEffect, useRef} from 'react';

import {useReviewRealtimePresence} from './review-realtime-presence-context';
import {ReviewPresenceActionEnum, ReviewPresenceActivityOptionsType} from './review-realtime-presence-type';

type SelectedReviewForPresenceType = {
    id: number;
    brand: {
        id: number;
    };
};

export function useBulkSelectPresenceSync(selectedReviews: Array<SelectedReviewForPresenceType>): void {
    const {startActivity, stopActivity} = useReviewRealtimePresence();
    const activeActivitiesRef = useRef<Map<number, ReviewPresenceActivityOptionsType>>(new Map());

    useEffect(() => {
        const selectedIds = new Set(selectedReviews.map((review) => review.id));
        const activeActivities = activeActivitiesRef.current;

        selectedReviews.forEach((review) => {
            if (!activeActivities.has(review.id)) {
                const options: ReviewPresenceActivityOptionsType = {
                    reviewId: review.id,
                    brandId: review.brand.id,
                    action: ReviewPresenceActionEnum.BulkSelect,
                };

                startActivity(options);
                activeActivities.set(review.id, options);
            }
        });

        [...activeActivities.keys()].forEach((reviewId) => {
            if (!selectedIds.has(reviewId)) {
                const options = activeActivities.get(reviewId);

                if (options) {
                    stopActivity(options);
                    activeActivities.delete(reviewId);
                }
            }
        });
    }, [selectedReviews, startActivity, stopActivity]);

    useEffect(() => {
        const activeActivities = activeActivitiesRef.current;

        return () => {
            activeActivities.forEach((options) => {
                stopActivity(options);
            });
            activeActivities.clear();
        };
    }, [stopActivity]);
}
